exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sett-estimates-footnote[data-v-2764d5e4] {\n  font-style: italic;\n}\n", ""]);

// exports
